import styled, { css } from 'styled-components'
import borders from '../theme/borders'
import color from '../theme/color'
import font from '../theme/font'
import space from '../theme/space'

export const Container = styled.div`
  position: relative;
  width: 100%;
`

export const SuggestionList = styled.ul`
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 0;
  right: 0;
  margin: ${space.xs2} 0 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
  background-color: ${color.grayscale.white};
  border: ${borders.sizes.sm} solid ${color.grayscale.light};
  border-radius: ${borders.radius.md};
  box-shadow: 0 0.25rem 0.75rem rgb(0 0 0 / 12%);
`

export const SuggestionItem = styled.li<{ $isHighlighted?: boolean }>`
  padding: ${space.xs} ${space.md};
  font-size: ${font.size.small};
  cursor: pointer;

  ${({ $isHighlighted }) =>
    $isHighlighted &&
    css`
      background-color: ${color.grayscale.lighter};
    `}
`
